export enum LocationType {
  HOME = 'HOME',
  WORK = 'WORK'
}
